export const COMBO_FETCHING_DATA = '[COMBO] fetching data';
export const COMBO_FETCHED_DATA = '[COMBO] fetched data';
export const COMBO_ADD_CUSTOM = '[COMBO] Custom combos added';
export const COMBO_INITIALIZE_COMPONENT = '[COMBO] initialize component Combos';
export const COMBO_INITIALIZE_COMBO = '[COMBO] initialize combo';
